import React from "react";
import "../../../styles/SimpleQuizz/BarreProgression.css";
import { QuizData } from "../../../data/quizzData";
import { calculateAnswersNumber } from "../../../data/utils";
export const BarreProgression = ({ userAnswers }) => {
  const progression = calculateAnswersNumber(userAnswers);
  return (
    <div className="container">
      <p>
        Vous avez complété {progression} questions sur {QuizData.length}
      </p>
    </div>
  );
};
